import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import { message } from "antd";
import ConsentServices from "../../Services/ConsentServices";
import content from "../../utils/TermsContent";

function ConsentComponent({
  selectedRecord,
  setConsentOpen,
  setShowModal,
  Appoinment,
}) {
  const patJson = sessionStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [consentdata, setConsentdata] = useState();
  const [checkedItems, setCheckedItems] = useState({
    terms: false,
    privacy: false,
    doctors: false,
    hospitals: false,
    pharmacy: false,
    diagnostics: false,
  });

  useEffect(() => {
    getConsent();
  }, []);

  const getConsent = async () => {
    const payload = {
      // account_Id: selectedRecord?.account_Id,
      // clinic_Id: selectedRecord?.clinic_Id,
      patientId: selectedRecord?.patientId,
    };

    try {
      const response = await ConsentServices.getconsentFilter(payload);

      setCheckedItems({
        terms: response.data[0].termsCond === "Y" ? true : false,
        privacy: response.data[0].privacyPolicy === "Y" ? true : false,
        doctors: response.data[0].shareMedWithDocs === "Y" ? true : false,
        hospitals: response.data[0].shareMedWithHosp === "Y" ? true : false,
        pharmacy:
          response.data[0].shareEpresWithPharmacy === "Y" ? true : false,
        diagnostics:
          response.data[0].shareEpresWithDiagnostics === "Y" ? true : false,
      });

      setConsentdata(response.data);
    } catch (e) {
      console.error("Error fetching consent:", e);
    }
  };

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const formatDate = () => {
    const now = new Date();
    return now
      .toLocaleString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", ""); // Remove the comma
  };

  const handleSubmit = async () => {
    try {
      const postData = {
        account_Id: selectedRecord?.account_Id,
        clinic_Id: selectedRecord?.clinic_Id,
        createdBy: patObj?.patientId,
        createdDate: formatDate(),
        modifiedBy: patObj?.patientId,
        modifiedDate: formatDate(),
        patientId: patObj?.patientId,
        privacyPolicy: checkedItems.privacy ? "Y" : "N",
        shareEpresWithDiagnostics: checkedItems.diagnostics ? "Y" : "N",
        shareEpresWithPharmacy: checkedItems.pharmacy ? "Y" : "N",
        shareMedWithDocs: checkedItems.doctors ? "Y" : "N",
        shareMedWithHosp: checkedItems.hospitals ? "Y" : "N",
        status: 1,
        termsCond: checkedItems.terms ? "Y" : "N",
      };

      const response = await ConsentServices.consentpost(postData);
      Appoinment(selectedRecord?.patientId);
      setConsentOpen(false);
      setShowModal(true);
      message.success("Consent submitted successfully!");
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Failed to submit consent. Please try again.");
    }
  };

  return (
    <div className="min-h-screen">
      <div className=" mt-5">
        <div className="font-bold text-xl">
          Give Consent To{" "}
          <span className="text-[#189FAA#189FAA]">
            {selectedRecord?.clinic_Name}
          </span>
          ,{" "}
          <span className="text-[#189FAA]">{selectedRecord?.account_Name}</span>
        </div>

        <div className="p-6 space-y-7 h-[550px] overflow-y-scroll scrollWidth">
          {/* Terms & Conditions */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="terms"
              checked={checkedItems.terms}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Terms & Conditions</span>
          </label>
          {checkedItems.terms && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.terms}
            </div>
          )}

          {/* Privacy Policy */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="privacy"
              checked={checkedItems.privacy}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Privacy Policy</span>
          </label>
          {checkedItems.privacy && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.privacyPolicy}
            </div>
          )}

          {/* Share Medical Records with Doctors */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="doctors"
              checked={checkedItems.doctors}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Share Medical Records with Doctors</span>
          </label>
          {checkedItems.doctors && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.shareMedRecWithDoc}
            </div>
          )}

          {/* Share Medical Records with Hospitals */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="hospitals"
              checked={checkedItems.hospitals}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Share Medical Records with Hospitals</span>
          </label>
          {checkedItems.hospitals && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.shareMedWithHos}
            </div>
          )}

          {/* Share e-Prescription with Pharmacy */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="pharmacy"
              checked={checkedItems.pharmacy}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Share e-Prescription with Pharmacy</span>
          </label>
          {checkedItems.pharmacy && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.ePresWithPhar}
            </div>
          )}

          {/* Share e-Prescription with Diagnostics */}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              name="diagnostics"
              checked={checkedItems.diagnostics}
              onChange={handleChange}
              className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
            />
            <span>Share e-Prescription with Diagnostics</span>
          </label>
          {checkedItems.diagnostics && (
            <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
              {content.ePresWithDiag}
            </div>
          )}
        </div>
        <div className="flex space-x-4 justify-end mt-5">
          {/* <button className="px-4 py-1 bg-gray-300 text-gray-900 rounded-lg hover:bg-gray-400">
              Cancel
            </button>  */}
          <button
            onClick={handleSubmit}
            className="px-4 py-1 bg-[#189FAA] text-white rounded-lg hover:bg-[#338f97]"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConsentComponent;
